import { motion } from "framer-motion";
import { Check, Download, RotateCcw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function QuoteSuccess({ result, email, onReset }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.97 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="relative overflow-hidden rounded-[28px] border border-cyan-300/25 bg-[#050811]/80 backdrop-blur-xl p-8 sm:p-12"
      data-testid="quote-success"
    >
      <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#5aec5a]/15 blur-[90px]" />
      <motion.div
        initial={{ scale: 0, rotate: -90 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 200, damping: 14, delay: 0.15 }}
        className="flex h-16 w-16 items-center justify-center rounded-full bg-brand"
      >
        <Check className="h-8 w-8 text-[#050811]" strokeWidth={3} />
      </motion.div>
      <h3 className="mt-8 font-display text-3xl sm:text-4xl font-semibold text-white">Demande envoyée.</h3>
      <p className="mt-4 max-w-lg text-base text-slate-300 leading-relaxed">
        Merci ! Votre demande <span className="font-mono-uc text-cyan-300" data-testid="quote-success-reference">{result?.reference}</span> a
        bien été transmise à UNDERCLEAN.
        {result?.confirmation_email_sent
          ? <> Un email de confirmation vient d'être envoyé à <span className="text-white">{email}</span>.</>
          : <> L'email de confirmation n'a pas pu être envoyé, mais votre demande est bien enregistrée.</>}
      </p>
      <div className="mt-10 flex flex-col sm:flex-row gap-4">
        <a
          href={`${API}/quotes/${result?.id}/pdf`}
          className="inline-flex items-center justify-center gap-3 rounded-full bg-brand px-7 py-4 font-semibold text-[#050811] hover:shadow-[0_0_40px_rgba(10,245,240,0.45)] transition-shadow duration-500"
          data-testid="quote-download-pdf-button"
        >
          <Download className="h-5 w-5" /> Télécharger le récapitulatif PDF
        </a>
        <button
          onClick={onReset}
          className="inline-flex items-center justify-center gap-3 rounded-full border border-white/20 px-7 py-4 text-white hover:border-cyan-300 transition-colors duration-300"
          data-testid="quote-new-request-button"
        >
          <RotateCcw className="h-4 w-4" /> Nouvelle demande
        </button>
      </div>
    </motion.div>
  );
}
